import AttendanceAdapter from './base';

export default class ResponseActivityConfiguration extends AttendanceAdapter {
  modelNamePlural = 'responseActivityConfigurations';
}
